<p-confirmDialog></p-confirmDialog>

<div class="flex shadow">
  <div class="grow p-4 pos-relative" (click)="navigateToEdit()" role="button"
       aria-roledescription="Bearbeite diesen Eintrag">
    <div class="grid grid-cols-12 gap-4">

      <div class="col-span-6 md:col-span-4 lg:col-span-2 my-auto">
        <div class="flex gap-2 items-center">
          <ng-icon name="matCalendarMonthSharp" class="my-auto"></ng-icon>
          <div class="flex gap-1 flex-col">
            <span>{{ weightEntry.weighedAt | date }}</span>
            <span>{{ weightEntry.weighedAt | date:"shortTime" }}</span>
          </div>
        </div>
      </div>

      <div class="col-span-6 md:col-span-4 lg:col-span-2 flex gap-2 my-auto items-center">
        <ng-icon name="matPetsSharp"></ng-icon>
        @if (weightEntry.rabbit.isDisabled) {
          <ng-icon name="gameSightDisabled" />
        }
        <div>{{ weightEntry.rabbit.name }}</div>
      </div>

      <div class="col-span-6 md:col-span-4 lg:col-span-2 flex gap-2 my-auto items-center">
        <ng-icon name="matScaleSharp"></ng-icon>
        <div>
          @if (weightEntry.weight != null) {
            {{ weightEntry.weight }} g
          } @else {
            -
          }
        </div>
      </div>

      @if (getMedicineAbbreviationList(); as medicineAbbreviations) {
        <div class="col-span-12 lg:col flex gap-2 my-auto items-center">
          <ng-icon name="matMedicationSharp"></ng-icon>
          <div>
            {{ medicineAbbreviations }}
          </div>
        </div>
      }

      @if (weightEntry.comment; as comment) {
        <div class="col-span-12 lg:col my-auto">
          <div class="flex gap-2 items-center">
            <ng-icon name="matCommentSharp" />
            <span>
              {{ comment }}
            </span>
          </div>
        </div>
      }

    </div>
  </div>
  <div class="bg-red-500 text-white text-center flex flex-col justify-center">

    <button type="button" title="Löschen" class="reset cursor-pointer primary-color-text p-4 h-full"
            (click)="confirmDeleteEntry()">
      <ng-icon name="matDeleteSharp"></ng-icon>
    </button>
  </div>
</div>
